import React from 'react';

const ATMASidebarDetails = ({ data, onClose, onViewBeneficiaryDetails }) => {
  if (!data) return null;

  const { demonstrationData, beneficiaries, error } = data;

  const handleClose = () => {
    // Call the onClose prop passed from parent
    if (onClose) {
      onClose();
    }
  };

  if (error) {
    return (
      <div className="atma-sidebar-details">
        <div className="atma-sidebar-header">
          <h4>ATMA Demonstration Details</h4>
          <button className="close-btn" onClick={handleClose}>×</button>
        </div>
        <div className="atma-sidebar-content">
          <div className="alert alert-danger">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="atma-sidebar-details">
      <div className="atma-sidebar-header">
        <h4>ATMA Demonstration Details</h4>
        <button className="close-btn" onClick={handleClose}>×</button>
      </div>

      <div className="atma-sidebar-content">
        {/* Beneficiaries Table */}
        <div className="beneficiaries-section">
          <h5>Beneficiaries ({beneficiaries?.length || 0})</h5>
          <div className="table-responsive">
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Farmer Name</th>
                  <th>Demo Area (Ha)</th>
                  <th>Polygon Drawn</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {beneficiaries?.map((beneficiary, index) => {
                  const hasPolygon = beneficiary.polygonShape && 
                                    beneficiary.polygonShape !== "null" &&
                                    beneficiary.polygonShape !== "N/A" &&
                                    beneficiary.polygonShape !== "";
                  
                  return (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{beneficiary.farmerName || `Beneficiary ${index + 1}`}</td>
                      <td>{beneficiary.demoAreaInHa || beneficiary.areaInHa || 'N/A'}</td>
                      <td className="text-center">
                        {hasPolygon ? 
                          <span className="badge bg-success">✓ Yes</span> : 
                          <span className="badge bg-danger">✗ No</span>
                        }
                      </td>
                      <td className="text-center">
                        <button 
                          className="btn btn-sm btn-primary"
                          onClick={() => onViewBeneficiaryDetails(beneficiary, index)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ATMASidebarDetails;